module.exports = __webpack_public_path__ + "static/media/programming-graphic.952da5c6.svg";